<template>
  <GamConfirmModal
    :title="title"
    :keep-label="localize('gambit.actions.leaveConfirmation.keep')"
    :destructive-label="localize('gambit.actions.leaveConfirmation.leave')"
    @close="emit('close')"
    @keep="emit('keep')"
    @confirm="emit('confirm')"
  />
</template>

<script setup lang="ts">
import { localize } from '@/core/gambits';
import GamConfirmModal from '@/views/components/GamConfirmModal.vue';

defineProps<{
  title: string;
}>();

const emit = defineEmits<{
  close: [];
  keep: [];
  confirm: [];
}>();
</script>
